<template>
  <div class="main-container">
    <div class="home-title" :class="[title_aligns?'text-'+title_aligns:'text-center ']" v-if="singlecommoditytitle">
        <h5>{{singlecommoditytitle}}</h5>
    </div>
    <hr v-if="theme=='showtime'" />
    <div class="product-template-section">
      <div class="container">
        <div class="product-left">
         <v-medialibrary singlecommodity="singlecommodity" :gallery="product_res.gallery" 
          :product_res="product_res"
              :productInfo="{
                ...product_info,
                stock: now_variant && now_variant.stock,
                sku: now_variant && now_variant.sku,
              }"></v-medialibrary>
        </div>
        <div class="product-right">
          <v-product-add
            ref="productadd"
            :theme="theme"
            :comment="comment"
            :stock="now_variant.buy_able&&stock"
            :product="product_res"
            :count_down="count_down"
            :count_down_show="count_down_show"
            :cart_type="cart_type"
            :show_currency_selector="show_currency_selector"
            :currency_style="currency_style"
            :paypal_product_position="paypal_product_position"
            :variants_show_config="variants_show_config"
            :bulk_coupon="bulk_coupon"
            :variant_attrs="variant"
            :add_cart_data="add_cart_data"
            :now_variant="now_variant"
            :enable_facebook="enable_facebook"
            :enable_twitter="enable_twitter"
            :enabel_pinterest="enabel_pinterest"
            :singlecommoditydescription="singlecommoditydescription"
            singlecommodity="singlecommodity"
            :buyxgety_coupon="false"
            :has_bulk_coupon="false"
            :code_display="false"
            :paypal_enabled="paypal_enabled"
            :palette_config="palette_config"
            :palette_attrs="palette_attrs"
            :computed_price="computed_price"
            :add_cart_list="add_cart_list"
            :show_comment_score="show_comment_score"
            :noshare="true"
          ></v-product-add>
          <div :a="show_detail" v-if="show_detail" class="product_single_item" :class="{'margin-bottom-20':theme === 'vogue'}">
            <div class="product_single_content">
              <div
                v-html="this.re_remover_class(product_res.post_content)"
                class="tinymce-content post_content default_css"
                style="overflow: hidden;overflow-x: auto;"
              ></div>
            </div>
          </div>
          <div v-if="!show_detail" class="view-detail" style="height:16px">
            <a
              style="text-decoration: underline;
    font-size: 16px;"
              :href="product_res.path"
              class="secondary_title main_button_color2"
            >
              {{ $t("singlecommodity.full_details") }}
              <span
                class="iconfont iconweb__bitebiyoujiantou"
              ></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vMedialibrary from "../../../../views/showtime/js/view/product/Medialibrary";
import vProductAdd from "../../../../views/venue/js/view/product/productAdd";
import getSymbolFromCurrency from "currency-symbol-map";
import mixProductTag from '@/js/mixins/mixProductTag';
import { mapActions, mapState } from "vuex";
import mixProduct from "@/js/mixins/mixProduct";
// import API from "@/js/API";

export default {
  props: [
    "product",
    "gallery_show_config",
    "count_down",
    "recommended_product",
    "variant_attrs",
    "bulk_coupon",
    "singlecommoditydescription",
    "show_detail",
    "palette_config",
    "singlecommoditytitle",
    "product_tag",
    "title_aligns",
    "comment",
  ],
  data() {
    return {
      product_res: {},
      count_down_show: false,
      variant: [], //绑定数据
      smallimg: [],
      show_recommended: "",
      pc_style: false,
      add_cart_data: {
        product_id: null,
        quantity: 1,
        // variant_id: null,
      },
      now_variant: {},
      getSymbolFromCurrency,
      stock: true,
      palette_attrs: [],

      price: 0, //产品卡片标签的价格
      regularPrice: 0,//产品卡片标签的原价格
       now_variant_list: [], //遇到需要特殊处理的属性需要保存多个已选变种
      add_cart_list: [], //遇到需要特殊处理的属性需要保存多个已选变种加购信息
      combinations: {}, //用于存放款式组合数据
      combination_active: 0, //款式组合当前商品索引
      mixin_in_product: true, //在min中判断是否为商品详情页的
    };
  },
  mixins: [mixProduct, mixProductTag],
  methods: {
    ...mapActions({
      get_product_tag: "change_product_tag_list", //获取产品tag
    }),
    add_cart() {
      this.$refs.productadd.add_cart();
    },
      ...mapActions({
      get_product_tag: "change_product_tag_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
    }),
  },
  beforeMount() {

    if (this.$(window).width() > 980) {
      this.pc_style = true;
    } else {
      this.pc_style = false;
    }
    if (this.recommended_product) {
      this.show_recommended = !this.recommended_product.shieldProduct.includes(
        this.product.ID
      );
    }
    if (this.palette_config) {
      let params = {
        'filter[product_id]': this.product.ID,
      }
      this.$axios.get(API.palette, { params }).then((res) => {
        if(res&&res.data&&res.data[this.product.ID]) this.palette_attrs = res.data[this.product.ID]
      })
    }
    if (this.product_tag) {
      this.get_product_tag(this.product.ID);
    }
    this.$store.dispatch("change_now_variant", this.now_variant);
    if (this.count_down) {
      this.count_down_show =
        this.count_down.detail.type == "all" ||
        this.count_down.detail.product_ids.includes(this.product.ID) ||
        this.count_down.detail.category_ids.some(item => {
          return this.product.categories.some(subitem => {
            return subitem.id == item;
          });
        });
    }
     if (this.product_tag) {
      this.get_product_tag(this.product_res.ID);
    }
  },
  created() {
    this.bus.$on("get_variant", (res) => {
      this.variant[res.index].value = res.val;
    });
  },

  computed: {
    ...mapState({
      paypal_enabled: ({ options }) => options?.base?.preferred_paypal_payment_method,
      paypal_product_position: ({ options }) => options?.base?.paypal_product_position,
      themeGlobalConfig: ({ options }) => options?.theme?.global || {},
      productConfig: ({ options }) => options?.theme?.pages?.product?.config || {},
      theme: ({ theme_name }) =>  theme_name
    }),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    show_comment_score() {
      return this.productConfig?.show_comment_score || false
    },
    variants_show_config() {
      return this.productConfig?.variants_show_config
    },
    currency_style() {
      return this.themeGlobalConfig?.currency_style || 'default'
    },
    enable_facebook() {
      return this.themeGlobalConfig?.social_medias?.enable_facebook || false
    },
    enable_twitter() {
      return this.themeGlobalConfig?.social_medias?.enable_twitter || false
    },
    enabel_pinterest() {
      return this.themeGlobalConfig?.social_medias?.enabel_pinterest || false
    },
    // 打开购物车类型
    cart_type() {
      return this.themeGlobalConfig?.cart?.type || 'page'
    },
    // 显示货币选择
    show_currency_selector() {
      // 旧数据兼容
      // themes_default.global.show_currency_selector = true
      // themes_default.global.show_currency_selector.show_selector = true
      const showCurrencySelector = this.themeGlobalConfig.show_currency_selector;
     
      if (showCurrencySelector.hasOwnProperty('show_selector')) {
        return showCurrencySelector.show_selector
      }
      return showCurrencySelector ? true : false
    }

  },
  components: {
    vMedialibrary,
    vProductAdd
  }
};
</script>

<style scoped lang='scss'>
.product-template-section {
  margin-top: 0px !important;
  .container {
    margin: 0;
    padding-left: 0px;
    padding-right: 0px;
    display: flex;
    padding-top: 30px;
    .product-left {
      width: 50%;
      padding-left: 0 !important;
    }
    .product-right {
      width: 50%;
      padding-left: 0 !important;
      h2 {
        color: #2f2f2f;
        font-size: 1.8662rem;
      }
      .product-description {
        p {
          margin-bottom: 0;
        }
        ul {
          li {
            list-style: inside;
          }
        }
        img,
        iframe,
        video {
          max-width: 100% !important;
        }
        pre {
          white-space: pre-wrap;
        }
      }
    }
  }
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
@media screen and (max-width: 768px) {
  .product-template-section {
    .title {
      width: 250px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
    }
    .container {
      flex-wrap: wrap;
      padding-top: 0px;
      .product-left {
        width: 100%;
        // .product-col-left {
        //   max-width: 100%;
        // }
      }
      .product-right {
        width: 100%;
        div {
          .select-sort-by {
            width: 100%;
          }
        }
        .product-description {
          margin-bottom: 15px;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .product-template-section {
    padding-bottom: 60px;
  }
}
</style>